var wm_scroll_var, wm_current_scroll_position;

jQuery(document).ready(function($){

    function wm_sticky_nav() {
        wm_current_scroll_position = $(this).scrollTop();
        $('body').toggleClass('nav-is-visible', wm_scroll_var > wm_current_scroll_position);
        wm_scroll_var = wm_current_scroll_position;

        $('[data-sticky]').toggleClass('is-stuck', wm_current_scroll_position !== 0);
    }

    $(window).scroll(Foundation.util.throttle(wm_sticky_nav, 200));

});
